<template>
  <div>
    <!-- <CongratulationsModal
      v-if="congratulationsModal"
      :deviceTag="newdeviceTag"
      :show="congratulationsModal"
      v-on:closeCongratulationsModal="congratulationsModal = false"
    /> -->
    <SuccessModal
      :show="showSuccessPopup"
      @close="handleCloseSuccess"
      :msg="$t('device_added_msg')"
      :heading="$t('device_added')"
    />
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>
    <div
      id="adddevice"
      class="modal fade"
      style="background: rgba(0,0,0,0.5)"
      :class="{ show: show }"
      tabindex="-1"
      role="dialog"
      aria-labelledby="vcenter"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" v-click-outside="onCancel" id="modal">
          <div class="card-body">
            <h5
              class="mx-0 px-2 pb-3"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              {{ $t("add-dev") }}
            </h5>
            <div
              v-if="mssg"
              class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ mssg }}
              </p>
            </div>
            <div
              v-else-if="Errormssg"
              class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ Errormssg }}
              </p>
            </div>
            <form class="p-2" @submit.prevent="adddevice">
              <div class="flex-con">
                <div class="form-group w-100">
                  <label>{{ $t("sel-dev-type") }}</label>
                  <select
                    v-model="deviceType"
                    name="user_right"
                    class="form-control"
                    required
                  >
                    <option value="mote">Mote </option>
                    <!-- <option value="coldBox">Cold Box</option> -->
                    <!-- <option value="novatrack">Novatrack</option> -->
                    <option value="lora">Lora</option>
                    <!-- <option value="gps-vt">Tracker</option> -->
                  </select>
                </div>

                <div class="form-group  w-100">
                  <label>{{ variableText.label }}</label>
                  <input
                    type="text"
                    name="imei"
                    v-model="imei"
                    class="form-control"
                    required
                  />
                </div>
              </div>
              <p class="mb-0 mt-2 gray4">
                <b>{{ $t("tip") }}</b
                >: {{ variableText.tips }}
              </p>
              <img
                class="mt-3 img"
                width="100%"
                height="180px"
                :src="variableText.img"
              />
              <div class="flex-con">
                <div class="form-group w-100">
                  <label>{{ $t("device-name") }}</label>
                  <input
                    type="text"
                    name="deviceName"
                    v-model="deviceName"
                    class="form-control"
                    :placeholder="$t('enter-device-name')"
                    required
                  />
                </div>

                <div class="form-group  w-100">
                  <label>{{ $t("device-location") }}</label>
                  <input
                    type="text"
                    name="deviceLocation"
                    v-model="deviceLocation"
                    class="form-control"
                    :placeholder="$t('enter-address')"
                  />
                </div>
              </div>
              <div class="flex-con">
                <div class="form-group w-100">
                  <label>{{ $t("minTemperature") }} (°C)</label>
                  <input
                    type="number"
                    name="minTemp"
                    v-model="minTemp"
                    class="form-control"
                    :placeholder="$t('enter-value')"
                    required
                  />
                </div>

                <div class="form-group  w-100">
                  <label>{{ $t("maxTemperature") }} (°C)</label>
                  <input
                    type="number"
                    name="maxTemp"
                    v-model="maxTemp"
                    class="form-control"
                    :placeholder="$t('enter-value')"
                    required
                  />
                </div>
              </div>
              <div class="flex-con">
                <div class="form-group w-100">
                  <label>{{ $t("min-humid") }} (%)</label>
                  <input
                    min="0"
                    type="number"
                    name="minHum"
                    v-model="minHum"
                    class="form-control"
                    :placeholder="$t('enter-value')"
                    required
                  />
                </div>

                <div class="form-group  w-100">
                  <label>{{ $t("max-humid") }} (%)</label>
                  <input
                    type="number"
                    name="maxHum"
                    v-model="maxHum"
                    class="form-control"
                    :placeholder="$t('enter-value')"
                    required
                  />
                </div>
              </div>
              <div
                class="form-group mb-0"
                style="display:flex; justify-content: end"
              >
                <button type="submit" class="btn btn-primary">
                  {{ $t("add-dev") }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";
import coldBox from "../../assets/images/Group 1315.png";
import mote from "../../assets/images/Mote.png";
import novatrack from "../../assets/images/Group 1316.png";
import lora from "../../assets/images/lora 2.png";
import SuccessModal from "./SuccessModal.vue";
// import CongratulationsModal from "./CongratulationsModal";

export default {
  name: "AddDevice",
  props: {
    show: Boolean,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      imei: "",
      mssg: "",
      Errormssg: "",
      deviceType: "mote",
      showSuccessPopup: false,
      deviceTag: "",

      deviceName: "",
      deviceLocation: "",
      minTemp: "",
      maxTemp: "",
      minHum: "",
      maxHum: "",
    };
  },
  components: {
    Loading,
    SuccessModal,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  computed: {
    ...mapGetters([]),
    variableText() {
      let variableText = {
        tips: "",
        label: "",
        img: "",
      };
      if (this.deviceType === "mote" || this.deviceType === "gps-vt") {
        variableText.tips = this.$t("mote-err");
        variableText.label = "IMEI";
        // variableText.img = '../../assets/images/imei-two.jpg';
        variableText.img = mote;
      }
      if (this.deviceType === "coldBox") {
        variableText.tips = this.$t("mote-err");
        variableText.label = "IMEI";
        variableText.img = coldBox;
      }
      if (this.deviceType === "novatrack") {
        variableText.tips = this.$t("nov-err");
        variableText.label = "IMEI/DevEui";
        variableText.img = novatrack;
      }
      if (this.deviceType === "lora") {
        variableText.tips = this.$t("lora-err");
        variableText.label = "IMEI/ID";
        variableText.img = lora;
      }

      return variableText;
    },
  },
  methods: {
    ...mapActions(["addDevice", "fetchallDevices"]),
    onCancel() {
      this.imei = "";
      this.Errormssg = "";
      this.$emit("closeDeviceModal");
    },
    adddevice() {
      // this.$router.push(`/devices/setupdevice/3467364736473`);
      this.isLoading = true;
      this.Errormssg = "";
      const newdevice = {
        name: this.deviceName,
        imei: this.imei,
        type: this.deviceType,
        location: this.deviceLocation,
        minTemperature: Number(this.minTemp),
        maxTemperature: Number(this.maxTemp),
        minHumidity: Number(this.minHum),
        maxHumidity: Number(this.maxHum),
      };
      this.addDevice(newdevice)
        .then((res) => {
          this.fetchallDevices()
          this.isLoading = false;
          this.onCancel();
          this.deviceTag = res.data.payload.deviceTag;
          // this.mssg =
          //   res.data.message[0].toUpperCase() + res.data.message.slice(1);
          // this.newdeviceTag = res.data.fridge.deviceTag;
          // setTimeout(() => {
          //   this.isLoading = true;
          // }, 1000);
          // setTimeout(() => {
          //   this.isLoading = false;
          //   // this.$emit("setup-device", res.data.fridge.deviceTag)
          //   this.$router.push(
          //     `/devices/setupdevice/${res.data.fridge.deviceTag}`
          //   );
          //   // console.log(res.data.fridge.deviceTag, "device Tag")
          //   this.onCancel();
          // }, 2000);

          this.showSuccessPopup = true;
        })
        .catch((error) => {
          this.isLoading = false;
          // this.Errormssg =
          //   error.response.data.message[0].toUpperCase() +
          //   error.response.data.message.slice(1);
          // error.response can be null
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
    handleCloseSuccess() {
      this.showSuccessPopup = false;
      this.$router.push(`/devices/setupdevice/${this.deviceTag}`);
    },
  },
};
</script>

<style scoped>
.img {
  width: 223px;
  height: 98px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 1rem;
  display: flex;
}

.flex-con {
  display: flex;
  gap: 1rem;
}

@media (min-width: 768px) {
  .modal-dialog {
    max-width: 500px !important;
  }
}
</style>

<i18n>
{
	"en": {
		"add-dev": "Add Device",
		"add-device": "Add a Device",
		"cancel": "Cancel",
		"lora-err": "The ID is the 8 digit number found at the bottom back of the device.",
		"mote-err": "The IMEI is the 15 digit number found at the bottom back of the device",
		"nov-err": "The DevEui is the 16 digit number found at the bottom back of the device.",
		"sel-dev-type": "Select Device Type",
		"tip": "Tip"
	},
	"fr": {
		"add-dev": "Ajouter un appareil",
		"add-device": "Ajouter un périphérique",
		"cancel": "annuler",
		"lora-err": "L'ID est le numéro à 8 chiffres situé en bas à l'arrière de l'appareil.",
		"mote-err": "L'IMEI est le numéro à 15 chiffres qui se trouve en bas à l'arrière de l'appareil",
		"nov-err": "Le DevEui est le numéro à 16 chiffres situé en bas à l'arrière de l'appareil.",
		"sel-dev-type": "Sélectionnez le type d'appareil",
		"tip": "Pointe"
	},
	"sw": {
		"add-dev": "Ongeza Kifaa",
		"add-device": "Ongeza Kifaa",
		"cancel": "Ghairi",
		"lora-err": "Kitambulisho ni nambari ya tarakimu 8 inayopatikana sehemu ya chini ya nyuma ya kifaa.",
		"mote-err": "IMEI ni nambari ya tarakimu 15 inayopatikana sehemu ya chini ya nyuma ya kifaa",
		"nov-err": "DevEui ni nambari ya tarakimu 16 inayopatikana sehemu ya chini ya nyuma ya kifaa.",
		"sel-dev-type": "Chagua Aina ya Kifaa",
		"tip": "Kidokezo"
	}
}
</i18n>
